import React from 'react'
import Fade from '@material-ui/core/Fade'
import Card from '@material-ui/core/Card'
import Grid from '@material-ui/core/Grid'
import { getDateFormated } from '../../js/helper'



const InboxItem = ({message, clickedMessageId}) => {

    const style = {
        inboxItem : {
            padding: '8px',
            cursor: 'pointer',
            backgroundColor: clickedMessageId===message.ids.messageId ? '#7986cb' : '',
            color: clickedMessageId===message.ids.messageId ? 'white' : ''
        }
    }
    

    return (
        <Fade in={true}>
                <Card
                    style={style.inboxItem}
                >
                    <Grid container spacing={0} alignItems='flex-start'>
                        <Grid item xs={12} md={3}>
                            <div>{getDateFormated(message.timeStamp, 'normal')}</div>
                        </Grid>
                        <Grid item xs={12} md={3}>
                            <div>{message.sender}</div>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <div>{message.subject}</div>
                        </Grid>
                    </Grid>
                </Card>
            </Fade>
    )
}

export default InboxItem


// WEBPACK FOOTER //
// ./src/Components/MessagingCenter/InboxItem.js